export default __webpack_public_path__ + "static/media/sweet-3.3a348f70.jpg";